import { TEST_ID_ORGANIZATION } from "e2e/testId";
import { Link } from "expo-router";
import { PlusCircleIcon } from "lucide-react-native";
import { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Button } from "@/components/atoms/Button";

/**
 * View component for the create organization navigation button.
 * Renders a plus icon button that links to the new organization form.
 */
const CreateOrganizationButtonView = () => (
  <Box className="pr-4">
    <Link asChild href="/organizations/new">
      {/* design-system: size snapped xl→lg (atom Button scale) */}
      <Button
        testID={TEST_ID_ORGANIZATION.CREATE_BUTTON}
        size="lg"
        variant="link"
        accessibilityLabel="Create organization"
        icon={PlusCircleIcon}
      />
    </Link>
  </Box>
);

CreateOrganizationButtonView.displayName = "CreateOrganizationButtonView";

export default memo(CreateOrganizationButtonView);
